import AnyColor from "@mapmycustomers/shared/types/AnyColor";
import { EntityPin } from "@mapmycustomers/shared/types/map";
import anyColorToHex from "@mapmycustomers/shared/util/color/anyColorToHex";
import getContrastColor from "@mapmycustomers/shared/util/color/getContrastColor";

import colors from "@app/styles/_colors.module.scss";

import ColorDefinition from "./types/ColorDefinition";

export const defaultColorBuilder = (color: AnyColor | null | undefined): ColorDefinition => {
  const fillColor = color ? anyColorToHex(color) : colors.slate;
  return {
    color: getContrastColor(fillColor) === "black" ? colors.slate : colors.white,
    fillColor,
  };
};

const defaultColorGetter = (entityPin: EntityPin): ColorDefinition =>
  defaultColorBuilder(entityPin.data.color);

export default defaultColorGetter;
